export const getStoredInfos = () => {
  const stored = JSON.parse(localStorage.getItem('persist:musical-match'))
  const profile = JSON.parse(stored.auth)
  
  return profile;
}